import styled from 'styled-components';

const ICON_SIZE = 22;

export const StyledWrapper = styled.aside`
  display: flex;
  justify-content: center;
  margin: '0 auto'
`;

export const StyledMessage = styled.span<{
  background: string;
}>`
  display: flex;
  padding: 16px 16px 0 16px;
  max-width: 800px;
  border-radius: ${({ theme }) => theme?.InlineMessage?.borderRadius};
  box-sizing: border-box;
  border: ${({ color, theme }) => color || theme.colors.mediumGray} 1px solid;
  background: ${({ background }) => background};
`;

export const StyledIcon = styled.svg<{
  color: string;
}>`
  position: relative;
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  fill: ${({ color, theme }) => color || theme.colors.mediumGray};
  top: ${({ theme }) => theme?.InlineMessage?.iconTop};
`;

export const StyledRowWrapper = styled.span`
  display: flex;  
  flex-basis: auto;
  margin-left: -8px;
  margin-right: -8px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledRow = styled.span`
  display: flex;
  flex-basis: auto;
  margin-left: -8px;
  margin-right: -8px;
  padding-left: 8px;
  padding-right: 8px;
`;

export const StyledIconCol = styled.span`
  padding-left: 8px;
  padding-right: 8px;
  flex-basis: auto;
`;

export const StyledMessageCol = styled.span`
  line-height: 1.5;
  flex-basis: auto;
  margin-bottom: 16px;
  padding-left: 8px;
  padding-right: 8px;
`;

export const StyledActionCol = styled.span`
  flex-basis: auto;
  padding-left: 8px;
  padding-right: 8px;
`;
